import React, { useEffect } from "react";

import { getPaymentLink, getSalesCalendarLink } from "@/utils/Local";

import LoaderComponent from "./Loader.component";

interface RedirectComponentProps {
  type: string;
}

const RedirectComponent: React.FC<RedirectComponentProps> = ({ type }) => {
  useEffect(() => {
    // Define redirection URLs based on type
    const typeToUrlMap: Record<string, string> = {
      sac: getSalesCalendarLink(),
      psd: getPaymentLink(),
    };

    if (type && typeToUrlMap[type]) {
      window.location.href = typeToUrlMap[type];
    } else {
      window.location.href = "";
    }
  }, [type]);

  return (
    <React.Fragment>
      <LoaderComponent /> Redirecting...
    </React.Fragment>
  );
};

export default RedirectComponent;
